import { Footer } from "../Footer/Footer"
import { HerosectionsAll } from "../HeroSectionAll/HerosectionsAll"
import { Header } from "../IndexPage/Header/Header"


export const Overview = () => {
    return (
        <>
            <div className="container-fluid">
                <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                    <div className="col-12">
                        <Header actives="Overview" subactive="About" />
                        <HerosectionsAll ScreenName="Overview" ScreenSearch="Vision" />

                        <div className="row p-2 px-lg-5 pt-lg-5">
                            <div class="container p-lg-5" style={{height:'auto'}}>

                                <ul class="timeline">
                                    <li>
                                        <div class="timeline-badge primary">
                                            <img src="Static/Assets/Img/vision_icon.png" width={50} alt="logo here" className="" />
                                        </div>
                                        <div class="timeline-panel animated slideInLeft p-lg-5" style={{ background: '#a5e6f8', border: '2px solid #49d3f9' }}>
                                            <div class="timeline-heading">
                                                <h4 class="timeline-title">Vision</h4>

                                            </div>
                                            <div class="timeline-body" >
                                                <p style={{ textAlign: 'justify' }}>"The Vision of MILSO is to create value for the Maritime and Insurance Industries globally, by sharing of knowledge, skills, learning and experience to develop and nurture professionalism."</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="timeline-inverted">
                                        <div class="timeline-badge warning">
                                            <img src="Static/Assets/Img/mission_icon.png" width={60} alt="logo here" className="" />
                                        </div>
                                        <div class="timeline-panel animated slideInRight p-lg-5">
                                            <div class="timeline-heading">
                                                <h4 class="timeline-title">Mission</h4>
                                            </div>
                                            <div class="timeline-body">
                                                <p style={{ textAlign: 'justify' }}>"We believe in continuous Professional Development (CPD) and strive for excellence in facilitating learning and simplify the understanding of how risk transfer by contracts and insurance are an indispensable link in managing risk effectively."</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="timeline-badge primary">
                                            <img src="Static/Assets/Img/Values_icon.png" width={55} alt="logo here" className="" />
                                        </div>
                                        <div class="timeline-panel p-lg-5"
                                            style={{ background: '#a5e6f8', border: '2px solid #49d3f9' }}>
                                            <div class="timeline-heading">
                                                <h4 class="timeline-title">Values</h4>
                                            </div>
                                            <div class="timeline-body">
                                                <p style={{ textAlign: 'justify' }}>"MILSO believes in striving to achieve professional independence and inter-dependence with Clients for mutual benefit by promoting empowerment of individuals, teams and organizations for growth and prosperity. We will be driven by ethical considerations at all times, never compromising on our values".</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="timeline-inverted">
                                        <div class="timeline-badge warning">
                                            <img src="Static/Assets/Img/Commitment_icon.png" width={60} alt="logo here" className="" />
                                        </div>
                                        <div class="timeline-panel p-lg-5">
                                            <div class="timeline-heading">
                                                <h4 class="timeline-title">Commitment</h4>
                                            </div>
                                            <div class="timeline-body">
                                                <p style={{ textAlign: 'justify' }}>"MILSO is committed to continual improvement to achieve excellence by practising equality, courtesy, empathy, understanding and respect for all we encounter".</p>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                            </div>

                        </div>

                        <Footer />
                    </div>
                </div>
            </div>

        </>
    )
}
